import { rankingDeProdutos } from '@/api/dados-produtos'
import 'reflect-metadata'
import { injectable } from 'inversify-props'
import { DadosDeProdutoServiceAdapter } from '@/usecases'

@injectable()
export class DadosDeProdutoService implements DadosDeProdutoServiceAdapter {
	findRanking = async (params: any, config?: any) => await rankingDeProdutos(params, config)
}
